var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{staticClass:"mb-4",attrs:{"color":"dark","icon-pack":"feather","icon":"icon-arrow-left"},on:{"click":_vm.regresar}},[_vm._v("Regresar")]),_c('informacion',{attrs:{"usuario":_vm.usuario}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }